import {
  Building2, HeartPulse, Dumbbell, Scissors, Stethoscope,
  ShoppingBag, Home, Briefcase, Heart, Clock, Star, Leaf,
  BarChart3, MapPin, Wind, Sparkles, FlaskConical, Fan, Package, Smartphone,
} from "lucide-react";

export const IMAGES = {
  heroHome:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/6d797b51cbd9c8ab20629d70a3122fafc60cba48e99e604e89f7b3833d3dfc04.jpeg",
  commercialHero:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/dfde9b295e3b2c5a770f4461611546970358e02438d585788f41e9630edb8814.jpeg",
  installService:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/5e39d901f1d2f1f80c3e0611a77fe3391437144ead79dc6d1c55d1ec8c0a9572.jpeg",
  heroLight:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/089125105f838f216e7411529224c66b39f51a84029cc6062ddc2b34142a83c8.png",
  heroStatic:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/ecf88a8dd933eabd5caf847fa21328f1edcedd6db82c005b5751bfdabc3d5ecf.jpeg",
  charcoalMarble:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/fe5d86950fc97d4c1e29c7e056dd4c0ef8b990ca4f6e7369e62e2eb24242b10d.jpeg",
  tailoredWide:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/415a64022e47bd0d991d28058fbab802bc7ffcb7b278353a7076ce256236eb61.jpeg",
  ctaStone:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/a4b95111d37bc22827ad93a30b80ef5cb8114c6d02d2e6e61610c4f408f3b73f.jpeg",
  smokeA:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/2175c0efc7d91b347ed45d8cd984fa9126eb10660ea7fcf8b8b1dc35532c4f68.png",
  smokeB:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/60ae156fcc9d52f12a13e88d7dc8e3c392b8c3fcc9f71dead6d5a692af3539be.png",
  lobbyReception:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/3fa7e70c0d6ff2854f63a321e8d2a5cd10771f32fcd2184b8865d4fac35e9a1a.png",
  heroReception:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/b31c59382584629283b4320f32710b3d26a7f46f3e25157509a43d6dd7d8431e.png",
  scienceScene:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/1eff7b8aedc03525a767196e79964bfc188da34b83d4996e0850ab49137ed292.png",
  productDiffuser:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/e281f5009218d82ea551780a207333d28a1a0e435bc719b0a6b38f67dcde8d25.png",
  heroBrand:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/64081118e23a59fddeaa67e8194b2601de49923b883cc9abce57cf54c8b5de85.jpeg",
  fragranceGlass:
    "https://images.pexels.com/photos/10924522/pexels-photo-10924522.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  perfumerCraft:
    "https://images.pexels.com/photos/8450514/pexels-photo-8450514.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  ingredients:
    "https://images.unsplash.com/photo-1676852148076-7a92002419f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  scentBottles:
    "https://images.unsplash.com/photo-1718466044521-d38654f3ba0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  catHero:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/16bc6aede544202a843d9ad0dec0a000f518bd9547181544747fa66874369ea4.jpeg",
  catSp01:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/fff2f84b382fc29cad618bd6f515397a5f5ddb61d65cf193abb832172a82cd30.jpeg",
  catMio1:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/7b9fbf9f8a49f03fbc0d39d45db2ca218a6019e82e430b49dae1f8770ad72ba8.jpeg",
  catLio1:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/c347287619782de270c7922b7e2cea1dd0f1741606fbaf0e48d646ce8270c946.jpeg",
  catScents:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/2454fcc8b96acdded4d40555c3d06d82f54ad121b49761bf71a80cd16344a639.jpeg",
  jDiffuser:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/cd77adfe8a37595f369b2d6a23b8a4f7cb1ccfdc541a36fcdf4761f2603edc1d.jpeg",
  jBottle:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/311afee58b271103e603e5fdd679d48734be2cdf68ae5fdff7a37948409b051b.jpeg",
  promiseScene:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/e495a737da64d690404cd3c85270e11dcf77c6f9b7473529b4a36793fbc82be3.jpeg",
  woodSlat:
    "https://static.prod-images.emergentagent.com/jobs/13a5f764-b0ec-4899-aac9-e0f4effd7d82/images/fa4e1a9fcf80597b8645adafdbe7953c74c4a76df10c101a1d1fe5929bf66126.jpeg",
  hotel:
    "https://images.unsplash.com/photo-1581115685033-ccf1aa701722?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  wellness:
    "https://images.unsplash.com/photo-1770625468009-791d7c5391f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  office:
    "https://images.unsplash.com/photo-1764410481612-7544525b2991?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  lobby2:
    "https://images.unsplash.com/photo-1637730827702-de34e9ae4ede?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  indHotel:
    "https://images.unsplash.com/photo-1629140727571-9b5c6f6267b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  indRecovery:
    "https://images.unsplash.com/photo-1773924093206-9a433a14bb44?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  indGym:
    "https://images.unsplash.com/photo-1740895307920-0ba63bffc1c9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  indClinic:
    "https://images.unsplash.com/photo-1705909773229-411dab40e09b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  indRetail:
    "https://images.pexels.com/photos/37793325/pexels-photo-37793325.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800",
  indOffice:
    "https://images.unsplash.com/photo-1764410481612-7544525b2991?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
};

export const INDUSTRY_CARDS = [
  { label: "Hotels", img: IMAGES.indHotel },
  { label: "Recovery Lounges", img: IMAGES.indRecovery },
  { label: "Gyms & Fitness", img: IMAGES.indGym },
  { label: "Medical Clinics", img: IMAGES.indClinic },
  { label: "Retail", img: IMAGES.indRetail },
  { label: "Offices", img: IMAGES.indOffice },
];

export const SERVICES = [
  { icon: Wind, title: "Commercial Scenting", body: "Waterless cold-air diffusion systems, precisely sized to your space for even, consistent fragrance." },
  { icon: Star, title: "Scent Marketing", body: "A signature scent that reinforces your brand, lifts mood and keeps customers coming back." },
  { icon: FlaskConical, title: "Custom Fragrance Development", body: "Bespoke fragrances crafted in-house to become a proprietary part of your identity." },
  { icon: Fan, title: "HVAC Integration", body: "Whole-building diffusion delivered quietly through your existing ductwork." },
  { icon: Package, title: "Diffuser Rental & Servicing", body: "All-inclusive monthly plans with maintenance, refills and support handled for you." },
  { icon: Smartphone, title: "App-Controlled Scheduling", body: "Set intensity, timing and zones remotely. Set it once and let it run." },
];

export const SPACES = [
  "Hotels & Resorts",
  "Recovery Lounges & Spas",
  "Gyms & Fitness Studios",
  "Salons & Barbers",
  "Medical & Dental Clinics",
  "Retail Stores & Showrooms",
  "Display Homes & Real Estate",
  "Corporate Offices & Receptions",
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Shop", to: "/shop" },
  { label: "Commercial Scenting", to: "/commercial-scenting" },
  { label: "Information", to: "/info" },
  { label: "Business Enquiries", to: "/enquiries" },
];

export const SCENT_STATS = [
  { value: "75%", label: "of all emotions we feel are generated by what we smell" },
  { value: "100×", label: "more likely to remember something you smell than something you see or hear" },
  { value: "84%", label: "of consumers say a pleasant atmosphere makes them more likely to come back" },
];

export const SCENT_REASONS = [
  { title: "What scent marketing actually is", body: "A deliberate, low-level fragrance running through your space — set so it reads as atmosphere rather than air freshener. Most customers never consciously notice it. They just like being there." },
  { title: "Why it works on people", body: "Smell is the only sense wired straight into the part of the brain that handles emotion and memory. It bypasses the thinking bit entirely, which is why a scent can bring a place back years later." },
  { title: "What it does for the room", body: "A well-judged scent makes a space feel cared for. Staff notice it first, then regulars, then everyone — mood lifts, people slow down, and the room stops smelling like a room." },
  { title: "Where it earns its keep", body: "Hotels, showrooms, gyms, clinics, salons and retail see it most clearly: longer visits, better reviews, and a venue people describe to their friends without knowing quite why." },
  { title: "Choosing the right one", body: "The scent has to match the brand, not just smell nice. We'll shortlist two or three that suit your space, let you live with them, and go with whichever your team keeps commenting on." },
  { title: "Keeping it consistent", body: "The difference between good and forgettable is consistency. We set intensity and schedule per zone, then adjust after a couple of weeks once we see how your space actually behaves." },
];

export const SCENT_PROCESS = [
  { no: "01", title: "We visit and measure", body: "Floor area, ceiling height, airflow, door traffic and trading hours. It all changes how much fragrance a room needs — guessing is how venues end up overpowering." },
  { no: "02", title: "You choose the scent", body: "We bring a shortlist matched to your brand and let you try them in the actual space. Or we develop something bespoke that's yours alone." },
  { no: "03", title: "We install it properly", body: "Wall-mounted, free-standing or straight into your HVAC. Cabling tidied, units sited out of the way, programmed and tested before we leave." },
  { no: "04", title: "We keep it running", body: "Refills, servicing and seasonal tweaks included. If something drops off, you call us — not a supplier in another state." },
];

export const SCENT_FACTS = [
  { value: "8,000m³", label: "Largest single-unit coverage" },
  { value: "No water", label: "Cold-air diffusion, no heat" },
  { value: "IFRA", label: "Compliant fragrance oils" },
  { value: "5–7 days", label: "Typical install lead time" },
];

export const SCENT_FAQS = [
  { q: "Will it be too strong?", a: "That's the most common worry and it's a sizing problem, not a fragrance problem. We calculate output against your room volume and airflow, start conservative, then adjust after a couple of weeks." },
  { q: "Is it safe in a clinic or around food?", a: "The oils are IFRA-compliant and formulated for continuous use in occupied public spaces, and Safety Data Sheets are available for every fragrance for your workplace records. Cold-air diffusion uses no heat and no flame." },
  { q: "Do we buy or rent the hardware?", a: "Either. Most venues go monthly with servicing and refills included; some prefer to own the units outright and just buy oil. We'll price both." },
  { q: "Can we use it across several sites?", a: "Yes — and that's usually the point. The same scent, same intensity, same experience in every location, managed from one account." },
  { q: "What happens if a unit plays up?", a: "Call us. Servicing is part of the agreement and we carry replacement units, so you're not waiting on a warranty claim." },
];

export const INDUSTRIES = [
  { icon: Building2, label: "Hotels" },
  { icon: HeartPulse, label: "Recovery Lounges" },
  { icon: Dumbbell, label: "Gyms" },
  { icon: Scissors, label: "Salons & Barbers" },
  { icon: Stethoscope, label: "Medical Clinics" },
  { icon: ShoppingBag, label: "Retail Stores" },
  { icon: Home, label: "Display Homes" },
  { icon: Briefcase, label: "Offices" },
];

export const FEATURES = [
  { icon: Heart, title: "Unforgettable first impressions", body: "A signature scent sets the tone the moment customers walk in." },
  { icon: Clock, title: "Increase customer dwell time", body: "The right scent keeps people comfortable and coming back." },
  { icon: Star, title: "Build a signature brand scent", body: "Create a unique identity that becomes part of your brand." },
  { icon: Leaf, title: "Safe, waterless technology", body: "Cold-air diffusion. No water, no heat, no mess." },
  { icon: BarChart3, title: "Proven business results", body: "Scent marketing increases sales and brand loyalty." },
  { icon: MapPin, title: "Australian owned & supported", body: "Local support and fast Australia-wide delivery." },
];

export const FEATURES4 = [
  { icon: Heart, title: "Build brand loyalty" },
  { icon: Clock, title: "Increase customer dwell time" },
  { icon: Leaf, title: "Waterless clean technology" },
  { icon: BarChart3, title: "Real business results" },
];

export const COLLECTIONS = [
  { name: "The Hotel Collection", tagline: "Inspired by the world's finest hotels.", img: IMAGES.hotel },
  { name: "The Wellness Collection", tagline: "Clean, calming fragrances for recovery lounges, spas and clinics.", img: IMAGES.wellness },
  { name: "The Executive Collection", tagline: "Sophisticated scents for offices and premium retail.", img: IMAGES.office },
];

export const STEPS = [
  { no: "01", title: "Choose your setup", body: "Start with a diffuser sized to your space — from a single reception to a whole-building HVAC system. We'll help you pick the right one." },
  { no: "02", title: "Pick your fragrance", body: "Choose from 30+ signature scents crafted in-house. Optionally subscribe for discounted refills that never run out." },
  { no: "03", title: "Install & enjoy", body: "Set it up yourself in minutes — or have us professionally install the device for you as part of your package." },
];

export const SPACE_TYPES = [
  "Hotel / Resort",
  "Retail Store / Showroom",
  "Office / Reception",
  "Gym / Fitness Studio",
  "Spa / Recovery Lounge",
  "Salon / Barber",
  "Medical / Dental Clinic",
  "Real Estate / Display Home",
  "Restaurant / Café",
  "Other",
];

export const TIMELINES = [
  "As soon as possible",
  "Within 1 month",
  "1–3 months",
  "Just exploring options",
];

export const BUDGETS = [
  "Under $100 / month",
  "$100 – $250 / month",
  "$250 – $500 / month",
  "$500+ / month",
  "Not sure yet",
];

export const HEAR_ABOUT = [
  "Google search",
  "Social media",
  "Referral / word of mouth",
  "Experienced it in a venue",
  "Other",
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Scent is memory",
    body: "Smell is the only sense wired directly to the limbic system — the part of the brain that governs emotion and memory. Before a guest reads your name or sees your logo, they have already felt your space. We design that feeling.",
  },
  {
    no: "02",
    title: "Atmosphere is a product",
    body: "The most memorable spaces in the world are not defined by furniture alone. They are composed. Light, sound, temperature, and scent working in quiet concert. We believe scent is the most overlooked, and most powerful, of them all.",
  },
  {
    no: "03",
    title: "Craft over noise",
    body: "We are not in the business of overwhelming a room. We are in the business of restraint — the precise dose, at the precise moment, delivered by technology that disappears into the background so the experience can step forward.",
  },
  {
    no: "04",
    title: "Built for business",
    body: "Every fragrance we release is measured against a single question: does it make people stay longer, feel better, and remember you? Beauty with intent. Atmosphere that performs.",
  },
];

export const FAQS = [
  { q: "How does cold-air diffusion work?", a: "Our diffusers use waterless cold-air technology to transform fragrance oils into a dry, micro-fine mist. No heat, no water, no residue — just consistent, even scent throughout your space." },
  { q: "What size spaces can you scent?", a: "Anything from a boutique reception area to whole-building HVAC integration. During your consultation we map your square metreage and airflow to recommend the right unit." },
  { q: "Are the fragrances safe?", a: "Yes. All fragrances are IFRA-compliant and formulated for continuous commercial use in public spaces, including medical and wellness environments." },
  { q: "Can I create a custom signature scent?", a: "Absolutely. Our in-house perfumers can develop a bespoke fragrance that becomes a proprietary part of your brand identity." },
  { q: "Do you offer rental or purchase?", a: "Both. Choose an all-inclusive monthly rental with servicing included, or purchase your diffusers outright and buy fragrance refills as needed." },
  { q: "How quickly can we get started?", a: "Most installations are scheduled within 5–7 business days of your consultation, Australia-wide." },
];

export const PLANS = [
  {
    name: "Boutique",
    price: "$89",
    period: "/month",
    desc: "For single reception areas, studios and small salons.",
    features: ["1 cold-air diffuser (up to 150m²)", "1 signature scent", "App scheduling", "Standard servicing"],
    featured: false,
  },
  {
    name: "Signature",
    price: "$219",
    period: "/month",
    desc: "For hotels, clinics, gyms and multi-zone spaces.",
    features: ["Up to 3 diffusers (up to 600m²)", "3 rotating scents", "Priority servicing", "Custom scheduling", "Dedicated account manager"],
    featured: true,
  },
  {
    name: "Bespoke",
    price: "Custom",
    period: "",
    desc: "HVAC integration and custom fragrance development.",
    features: ["Whole-building HVAC diffusion", "Custom signature fragrance", "White-glove installation", "SLA-backed servicing"],
    featured: false,
  },
];

export const COVER_INDUSTRIES = ["Hotels", "Offices", "Retail", "Clinics", "Gyms", "Salons", "Wellness Spaces"];

export const JOURNEY = [
  { no: "1", title: "Select Your Diffuser", body: "Find the perfect scenting system to suit your space and coverage." },
  { no: "2", title: "Discover Your Signature Scent", body: "Choose from our curated collection of premium fragrances, crafted to enhance every space." },
  { no: "3", title: "Professional Installation", body: "Our experienced team installs and optimises your system for seamless performance and reliability." },
];

export const COMMITMENT = [
  { title: "Safety Data Sheets", body: "Comprehensive Safety Data Sheets (SDS) are available for every fragrance upon request, providing complete ingredient and safety information for your workplace records." },
  { title: "IFRA-Compliant Fragrances", body: "All fragrance oils supplied by The Scent Butler comply with the latest IFRA standards, ensuring safe and responsible use in commercial environments." },
  { title: "Non-Toxic Formulations", body: "Our premium fragrance oils are non-toxic and free from harsh chemicals, designed for safe everyday use in occupied commercial spaces when used as directed." },
  { title: "Professional Installation", body: "Every commercial system is installed and configured by our experienced team to ensure optimal performance, reliability and safe operation." },
];

export const COMPLIANCE = [
  "IFRA-compliant fragrance oils",
  "Safety Data Sheets (SDS) available on request",
  "Non-toxic formulations",
  "Cold-air diffusion technology (no heat or flame)",
  "Suitable for commercial and public environments",
  "Professional installation & ongoing servicing",
];

export const STATS = [
  { value: "30+", label: "Signature fragrances" },
  { value: "1,200+", label: "Spaces scented" },
  { value: "8", label: "Industries served" },
  { value: "100%", label: "Australian owned" },
];

export const TESTIMONIALS = [
  { quote: "Guests started asking what the scent was within the first week. It's become part of how people describe staying with us.", author: "Operations Manager", org: "Boutique hotel group, Sydney" },
  { quote: "The team came out, measured the space and had the whole thing installed in an afternoon. I haven't had to think about it since.", author: "Owner", org: "Day spa, Gold Coast" },
  { quote: "We trialled it in one store first. People clearly lingered longer, so we rolled it out to all four.", author: "Retail Manager", org: "Fashion label, Melbourne" },
];

export const VENUE_TYPES = [
  "Boutique Hotels", "Luxury Spas", "Fitness Clubs", "Fashion Retail",
  "Medical Suites", "Corporate HQ", "Display Homes", "Fine Dining",
];

export const CRAFT = [
  { no: "01", title: "Sourced", body: "We source premium fragrance oils and raw materials from trusted perfume houses in Grasse and beyond." },
  { no: "02", title: "Composed", body: "Our in-house perfumers layer top, heart and base notes into balanced, long-lasting signature accords." },
  { no: "03", title: "Engineered", body: "Each scent is calibrated to our waterless cold-air diffusion for an even, consistent throw across any space." },
  { no: "04", title: "Delivered", body: "We install, service and refine on-site — so your signature scent stays flawless, season after season." },
];

export const SUSTAINABILITY = [
  { title: "Waterless technology", body: "Cold-air diffusion uses no water and no heat — lower energy use and zero residue." },
  { title: "IFRA-compliant", body: "Every fragrance meets international safety standards for continuous use in public spaces." },
  { title: "Refill, don't replace", body: "Recyclable refills and durable hardware keep waste to an absolute minimum." },
  { title: "Blended in Australia", body: "Composed locally to reduce freight miles and support Australian craft." },
];

export const SCENT_FAMILIES = [
  { name: "Fresh & Citrus", notes: "Bergamot · Neroli · Sea Salt", body: "Bright, clean and energising — ideal for gyms, clinics and modern retail." },
  { name: "Floral & Green", notes: "Jasmine · Peony · Fig Leaf", body: "Soft and welcoming — perfect for spas, salons and reception spaces." },
  { name: "Woody & Amber", notes: "Sandalwood · Oud · Amber", body: "Warm and grounding — a signature for hotels and executive suites." },
  { name: "Gourmand & Spice", notes: "Vanilla · Tonka · Cardamom", body: "Rich and memorable — enveloping scents for hospitality and lounges." },
];
